import { createPlatform, Injectable } from '@angular/core';
import { buffer, Observable, Subject } from 'rxjs';

//import { Md5 } from 'ts-md5/dist/md5';
import { Md5 } from 'ts-md5';
import * as CryptoJS from 'crypto-js';
import { LoginResponse } from '../model/response/auth-r';
import { TokenR } from '../model/response/token-r';
import { Title } from '@angular/platform-browser';
import { Session, Tokens, User } from '../features/login/login';
import { customBreadCrumbRequest } from '../core/bread-crumbs/bread-crumbs.component';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  ID: string = '';
  private secretKey: string = "K09Yol0lUwU8844ToieOwOara1ArAo00Astolfo8453o69opysassj0wodczas56";
  //for dynamic title
  private storageSub = new Subject<String>()
  public  breadCrumSub$ = new Subject<customBreadCrumbRequest>();

  //key to retreive session
  private readonly userDataKey = 'UD';
  //key to retreive GUID
  private readonly guidKey = 'GD';
  //key to retreive tokens
  private readonly tokensKey = 'TT';

  constructor(private titleService: Title) { }
  menuReady$ = new Subject<boolean>();
  /**
   * encrypt a string with a secret key
   */
  encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this.secretKey.trim()).toString();
  }
  /**
  * encrypt a string with a secret key and replace the / with something else
  */
  encryptNoSlash(value: string): string {
    let withSlash = CryptoJS.AES.encrypt(value, this.secretKey.trim()).toString();
    return withSlash.replaceAll('+', 'usdHJK473').replaceAll('/', 'dfs678GH').replaceAll('=', 'hjkHKJ742l');
  }

  /**
  * decrypt a string with a secret key
  */
  decryptNoSlash(value: string): string {
    value = value.replaceAll('usdHJK473', '+').replaceAll('dfs678GH', '/').replaceAll('hjkHKJ742l', '=');
    return CryptoJS.AES.decrypt(value, this.secretKey.trim()).toString(CryptoJS.enc.Utf8);
  }


  /**
   * decrypt a string with a secret key
   */
  decrypt(value: string): string {
    return CryptoJS.AES.decrypt(value, this.secretKey.trim()).toString(CryptoJS.enc.Utf8);
  }





  /**
   * changes current page title on header
   * @param titolo 
   */
  public setTitolo(titolo: string) {
    localStorage.setItem(`TL`, titolo);
    this.storageSub.next('changed');
    this.titleService.setTitle(`${titolo}`);
  }

  public setCustomBreadCrumb(request: customBreadCrumbRequest) {
    console.warn('\n \n \n trigger breadcrumb change \n \n \n');
    this.breadCrumSub$.next(request);
  }


  /**
   * gets titolo from local storage and returns to header
   * @returns titolo
   */
  public getTitolo(): string {
    return localStorage.getItem(`TL`) || '';
  }

  /**
   * triggers title change on header
   * @returns observable that tells the title is changed
   */
  watchTitle(): Observable<any> {
    return this.storageSub.asObservable();
  }


  /**
   * get value from local storage
   * @param valueName value key to write
   * @param value value to write
   */
  public addValue(valueName: string, value: any) {
    localStorage.setItem(valueName, this.encrypt(value));
  }

  /**
   * get value from local storage
   * @param valueName 
   * @returns the value or null if it is not found
   */
  public getValue(valueName: string): any | null {
    if (localStorage.getItem(valueName)) {
      return this.decrypt(localStorage.getItem(valueName) || '');
    } else {
      return null;
    }
  }

  /**
   * removes a value from local storage
   * @param valueName key to delete from local storage
   */
  public deleteValue(valueName: string) {
    if (localStorage.getItem(valueName)) {
      localStorage.removeItem(valueName);
    }
  }


  /**Save guid to local storage
 * @param guid 
 */
  saveTokens(tokens: Tokens) {
    let tokensEncrypted = this.encrypt(JSON.stringify(tokens));
    localStorage.setItem(this.tokensKey, tokensEncrypted)
  }


  /**
     * get guid from local storage
     * @return guid
     */
  getTokens(): Tokens | undefined {
    let tokensString = localStorage.getItem(this.tokensKey);
    if (tokensString) {
      try {
        let tokens = JSON.parse(this.decrypt(tokensString)) as Tokens;
        return tokens;
      } catch (ex) {
        return undefined;
      }
    }
    else
      return undefined;
  }

  /**Save guid to local storage
   * @param guid 
   */
  saveGUID(guid: string) {
    let guidEncrypted = this.encrypt(guid);
    localStorage.setItem(this.guidKey, guidEncrypted)
  }


  /**
     * get guid from local storage
     * @return guid
     */
  getGUID(): string | undefined {
    let guidString = localStorage.getItem(this.guidKey);
    if (guidString)
      return this.decrypt(guidString)
    else
      return undefined;
  }

  /**
   * save session to local storage
   * @param data current session
   */
  saveUserData(data: User) {
    let sessionEncrypted = this.encrypt(JSON.stringify(data));
    localStorage.setItem(this.userDataKey, sessionEncrypted)
  }


  /**
     * get session from local storage
     * @return session
     */
  getUserData(): User | undefined {
    let sessionString = localStorage.getItem(this.userDataKey);
    if (sessionString) {
      try {
        let session = JSON.parse(this.decrypt(sessionString)) as User
        return session;
      } catch (ex) {
        return undefined;
      }
    } else {
      return undefined;
    }


  }

  /**
   * clears local storage
   */
  clearSession() {
    localStorage.clear();
  }


  /**
   * write to cookie app theme
   * @param value the theme value
   */
  setAppTheme(value: string) {
    // Calculate expiration date 1 year from now
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);

    // Convert expiration date to UTC string format
    const expires = expirationDate.toUTCString();

    // Set the cookie with the expiration date
    document.cookie = `theme=${value}; expires=${expires}; path=/`;
    //document.cookie = `theme=${value};` 
  }

  /**
   * read from cookies the theme that is selected
   * @returns current theme
   */
  getAppTheme(): string {
    return document.cookie.split(';').find(x => x.includes('theme'))?.split('=')[1] || '';
  }


  /**
   * This function save the value for a cookie, if a cookie with the given cookie name exist it's updated
   * @param cookieName cookie name
   * @param value the cookie value to save
   */
  setCookie(cookieName: string, value: any) {
    // Calculate expiration date 1 year from now
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);
    // Convert expiration date to UTC string format
    const expires = expirationDate.toUTCString();

    document.cookie = `${cookieName}=${value}; expires=${expires}; path=/`;
  }

  /**
   * This function return the value of an existing cookie
   * @param cookieName cookie name
   * @returns value of the cookire or undefined
   */
  getCookie(cookieName: string): string | undefined {
    return document.cookie.split(';').find(x => x.includes(cookieName))?.split('=')[1] || undefined;
  }

  /**
   * This function delete a cookie, kinda: it actually change the cookie value to null and make it expire
   * @param cookieName the cookieName to delete
   */
  deleteCookie(cookieName: string) {
    // Set the cookie's expiration date to a past date to remove it.
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }

}
